import axios from 'axios';
import { encryptApiKey } from "./cryptoUtils";
import server from "./serverConfig";

// Create a custom axios instance
const apiClient = axios.create({
    baseURL: "https://choice.server.sypto.xyz/"
});

// Automatically intercept every request to append the token
apiClient.interceptors.request.use((config) => {
    // Only attach JWT tokens if the target is our secure Choice backend
    const url = config.url || '';
    const targetUrl = url.startsWith('http') ? url : ((config.baseURL || '') + url);
    const isGodseyeBackend = targetUrl.includes("choice.server.sypto.xyz") ||
        targetUrl.includes(server.godseye.baseUrl) ||
        targetUrl.includes('localhost') ||
        targetUrl.includes('127.0.0.1') ||
        targetUrl.includes('0.0.0.0') ||
        targetUrl.includes('sypto.xyz');

    if (isGodseyeBackend) {
        // Determine API keys from Environment Variable or defaults
        const apiKey = process.env.REACT_APP_API_KEY || "choice_frontend_key_123";
        const secretKey = process.env.REACT_APP_SECRET_KEY || "choice_secret_key_456";

        // Generate fresh short-lived JWT token
        const token = encryptApiKey(apiKey, secretKey);
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default apiClient;
